import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=295a14d2"
import script from "./InputCurrency.vue?vue&type=script&lang=ts"
export * from "./InputCurrency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports